export const getPopupContentStyle = (isMobile: boolean): Record<string, string> => ({
  width: isMobile ? '100%' : 'auto',
  height: isMobile ? '100%' : 'auto',
  padding: isMobile ? '1.25rem 1.25rem 1.375rem' : '1.5rem 1.875rem 1.375rem',
});
